<template>
  <div class="mapBox" :style="{height: mapHeight + 'px'}">
    <baidu-map v-bind:style="mapStyle" class="bm-view" :center="center" :zoom="zoom"
               ak="cFjSMpp64eGNPQZ63hYfoh6POgmZdmr0" :scroll-wheel-zoom="true"
               @zoomend="syncCenterAndZoom" @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom"
               @ready="mapHandler" :map-click="false">
<!--      <bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
        <bm-label content="坐标点" :labelStyle="{color: 'red', fontSize: '12px', padding: '5px 10px'}"
                  :offset="{width: 23, height: 2}"/>
      </bm-marker>-->
      <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                      :offset="{width: 20, height: 100}"
                      :autoLocation="true"></bm-geolocation>
      <bm-control :offset="{width: '10px', height: '10px'}">
        <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 99999}">
          <input type="text" placeholder="请输入搜索关键字" ref="serachinput" class="serachinput">
        </bm-auto-complete>
      </bm-control>
      <bm-local-search :keyword="keyword" :auto-viewport="true"></bm-local-search>

    </baidu-map>
    <img class="maker" src="../../assets/images/red_marker.png">
    <p class="point">经度：{{center.lng}}, 纬度： {{center.lat}}</p>
    <div class="footer">
      <div class="submit">
        <van-button type="default" @click="cancel">取 消</van-button>
        <van-button type="primary" @click="confirm">确 定</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BaiduMap,
  BmGeolocation,
  BmControl,
  BmAutoComplete,
  BmLocalSearch,
  // BmMarker,
  BmLabel
} from 'vue-baidu-map';
import { debounce } from '@/utils/publicFun'

export default {
  components: {
    BaiduMap,
    BmGeolocation,
    BmControl,
    BmAutoComplete,
    BmLocalSearch,
    // BmMarker,
    BmLabel
  },
  props: {
    mapHeight: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      BMap: {},
      map: {},
      center: {lng: 116.404, lat: 39.915},
      zoom: 15,
      mapStyle: {
        width: '100%',
        height: this.mapHeight + 'px'
      },
      keyword: '',
      iconUrl: 'https://api.map.baidu.com/images/marker_red_sprite.png'
    }
  },
  mounted() {
      // this.dragging = debounce(this.dragging, 100);
  },
  methods: {
    mapHandler({BMap, map}) {
      this.BMap = BMap; // 核心类
      this.map = map; // 地图实例
      this.getCurlocation(); // 定位
    },
    getCurlocation() { // 获取浏览器当前定位
      if (!this.BMap) return false;
      let BMap = this.BMap;
      let geolocation = new BMap.Geolocation();
      let _this = this;
      geolocation.getCurrentPosition(r => {
        _this.center = r.point;
      });
      // var myP1 = new BMap.Point(_this.center.lng, _this.center.alt);   // 点
      // var m1 = new BMap.Marker(myP1);         // 创建
      // this.map.addOverlay(m1);
    },
    getClickInfo(e) { // 地图点击事件
      this.center.lng = e.point.lng;
      this.center.lat = e.point.lat;
    },
    syncCenterAndZoom(e) {
      const {lng, lat} = e.target.getCenter();
      this.center = {
        lng: lng.toFixed(6),
        lat: lat.toFixed(6)
      }
      this.zoom = e.target.getZoom();
      this.$refs.serachinput.blur();
    },
    /***
     * 确认
     */
    confirm() {
      // console.log(this.center)
      this.$emit('getCenter', {address: this.keyword || '', ...this.center});
    },
    /***
     * 取消
     */
    cancel() {
      this.$emit('closeMap');
    }
  }
}
</script>

<style lang="stylus">
.mapBox
  width 100%
  display flex
  flex-direction column
  overflow hidden

  .bm-view
    flex 1
    height 100%
    width 100%

    .anchorBL
      display none

    .anchorTL
      width 100%
      padding 9px

      .serachinput
        width 96%
        display block
        padding 9px
        box-sizing border-box
        border 1px solid #dddee1
        line-height 20px
        font-size 14px
        height 38px
        color #333
        position relative
        border-radius 4px
        box-shadow #666 0px 0px 10px

  .maker
    position fixed
    top 50%
    left 50%
    z-index 999
    margin-left -16px
    margin-top -16px

  .point
    position fixed
    bottom 65px
    left 10px
    height 40px
    line-height 40px
    padding 0 15px
    z-index 999
    width 70%
    background #fff
    border-radius 4px
    box-shadow #666 0px 0px 10px
    font-size 14px
    color #333

  .footer
    position fixed
    bottom 0
    height 60px

    z-index 999
    width 100%
    background #f1f1f1
    box-shadow #666 0px 0px 10px

    .submit
      text-align center
      height 60px
      line-height 60px
      margin 0
      align-items center

      button
        width 30%
        margin 0 5%
        height 40px
        line-height 40px

  .pointImg
    position fixed
    top 50%
    left 50%
    margin-top -30px
    margin-left -16px
    z-index 9999

span
  overflow inherit
</style>
